module.exports = {
    el: '#wrapper',

    data: {
        navOpen:            false,
        showContactInNav:   false,
        aboutDropdownShown: false,
        windowSize:         0
    },

    mounted() {
        return Vue.nextTick(function() {
            $(document).trigger("domReady");

            initCustomForms();
            inittopOffset();
            initSameHeight();
            initSlideShow();
            initTouchNav();
            initDropDownClasses();
            return initMobileNav();
        });
    },

    created() {
        this.windowSize = $(window).width();
        $(window).resize(() => {
            return this.windowSize = $(window).width();
        });
        bus.$on('toggleNav', val => {
            return this.navOpen = !!val;
        });
        return this.$nextTick(function() {
            if (window.location.hash && $(window.location.hash).length) {
                const offset = parseInt($(window.location.hash).offset().top);
                return $('html, body').stop().animate({
                    scrollTop: offset
                }, 1000);
            }
        });
    },

    watch: {
        navOpen(val) {
            $('body').toggleClass('nav-open', !!val);
            if (!this.navOpen) {
                return this.showContactInNav = false;
            }
        }
    },

    methods: {
        emit(eventName, data) {
            if (data == null) { data = {}; }
            return bus.$emit(eventName, data);
        },

        toggleNav() {
            return this.navOpen = !this.navOpen;
        },

        normalLinkHandler(e) {
            if (this.showContactInNav) {
                e.preventDefault();
                return setTimeout(() => {
                    return this.showContactInNav = false;
                }
                , 50);
            }
        },

        toggleAboutDropdown(e) {
            e.preventDefault();
            this.aboutDropdownShown = !this.aboutDropdownShown;
            return $(this.$refs.about).stop().slideToggle(this.aboutDropdownShown);
        },

        _emit(event, ...data) {
            return bus.$emit(event, data);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/AppBase.js